module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 account_section"
  }, [_c('div', {
    staticClass: "my-account-title"
  }, [_vm._v("Lab Information")]), _vm._v(" "), _c('div', {
    staticClass: "account_login_info"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('p', {
    staticClass: "account_p"
  }, [_vm._v("At this time, orders are being routed to designated labs. \n          Please check your order confirmation to find the mailing address of the lab for that order. \n          Check the Track Order page of the website for information about order status. Contact support if you have any questions.\n        ")])])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36f47818", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36f47818"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/userAccount/accountData/LabInfo.vue
// module id = 488
// module chunks = 3